import { render } from "./template_sms_add.vue?vue&type=template&id=353c78ca&scoped=true"
import script from "./template_sms_add.vue?vue&type=script&lang=js"
export * from "./template_sms_add.vue?vue&type=script&lang=js"

import "./template_sms_add.vue?vue&type=style&index=0&id=353c78ca&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353c78ca"]])

export default __exports__